module.exports = "/dist/img/info.a50210738ce3bfd37a1e247fbb961813.svg";